// import React from 'react';
// import Image from 'react-bootstrap/Image';
// import styles from './styles.module.scss';

// export default function WorkPage() {
//     const image1 = 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg';
//     const image2 = 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495581/FASADE_1_ifln4r.jpg'
//     const image3 = 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495577/FASADE_BILDE_tl41ya.jpg';
//     const image4 = 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735496509/FASADE_5_xmn8t8.jpg';
//     const image5 = 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735496510/FASADE_4_ordfg5.jpg';
//     const image6 = 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735496517/FASADE_3_mqhqxj.jpg';

//     const projects = [
//         {
//             name:'Black Ceramic',
//             link: '/projects/black-ceramic',
//             fasadeImg: 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//             images: [
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//                 'https://res.cloudinary.com/dfgsj88iu/image/upload/f_webp/v1735495584/FASADE_BILDE_1_nhtne2.jpg',
//             ]
//         },
//     ]

//     return(
//         <div className={`home-container ${styles.masonryLayout}`}>
//             <div className={`${styles.masonryItem}`}>
//                 <div className={styles.overlay}>
//                     <p className="overlayText">Black Ceramic</p>
//                 </div>
//                 <Image className={styles.imageCard} fluid alt="img1" src={image1}/>
//             </div>
//             <div className={`${styles.masonryItem}`}>
//                 <div className={styles.overlay}>
//                     <p className="overlayText">The National Museum - Oslo</p>
//                 </div>
//                 <Image className={styles.imageCard} fluid alt="img1" src={image2}/>
//             </div>
//             <div className={`${styles.masonryItem}`}>
//                 <div className={styles.overlay}>
//                     <p className="overlayText">Oslo Keramikkverksted</p>
//                 </div>
//                 <Image className={styles.imageCard} fluid alt="img1" src={image6}/>
//             </div>
//             <div className={`${styles.masonryItem}`}>
//                 <div className={styles.overlay}>
//                     <p className="overlayText">Architecture in Oslo</p>
//                 </div>
//                 <Image className={styles.imageCard} fluid alt="img1" src={image3}/>
//             </div>
//             <div className={`${styles.masonryItem}`}>
//                 <div className={styles.overlay}>
//                     <p className="overlayText">Xpeng - Oslo Showroom</p>
//                 </div>
//                 <Image className={styles.imageCard} fluid alt="img1" src={image4}/>
//             </div>
//             <div className={`${styles.masonryItem}`}>
//                 <div className={styles.overlay}>
//                     <p className="overlayText">Magnus Improshow - Oslo</p>
//                 </div>
//                 <Image className={styles.imageCard} fluid alt="img1" src={image5}/>
//             </div>
//         </div>
//     )
// }

import React from 'react';
import { useNavigate } from 'react-router';
import styles from './styles.module.scss';
import Unavailable from '../../components/unavailable';
import Picture, { SIZES } from '../../components/picture';
import { useContent } from '../../content/ContentProvider';
import Spinner from 'react-bootstrap/Spinner';


export default function WorkPage() {
    const navigate = useNavigate();
    const { status, projects } = useContent();

      // The spinner shows only while the list of projects is on its way. The
      // covers then arrive into places already kept for them.
      if (status === 'loading') {
        return (
            <div className="col-12 m-auto d-flex flex-column align-items-center justify-content-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Laster inn prosjekter...</span>
            </Spinner>
          </div>
        );
      }

      if (status === 'error') {
        return <Unavailable />;
      }

      const handleNavigation = (slug) => {
        navigate(`/projects/${slug}`);
      };

    return (
        <div className={`home-container ${styles.masonryLayout}`}>
            {projects.map((project, index) => (
                <div key={index} className={`${styles.masonryItem}`} onClick={() => handleNavigation(project.slug)}>
                    <div className={styles.overlay}>
                        <p className="overlayText">{project.name}</p>
                    </div>
                    <Picture className={`img-fluid ${styles.imageCard}`} image={project.cover} sizes={SIZES.grid} priority={index < 2} fade alt={project.name}/>
                </div>
            ))}
        </div>
    );
}
